'use strict';

angular.module('app').directive('resizeItem', function($timeout) {

    var link = function(scope, elem) {
        var thisElem = $(elem);

        scope.$watch('resizeItem', function(newVal) {
            if (newVal === 3) {
                $timeout(function() {
                    var step2 = $('.finished-step2');

                    thisElem.css('height', step2.outerHeight() + 'px');
                    step2.css('height', step2.outerHeight() + 'px');
                });
            } else {
                thisElem.css('height', '');
            }
        });
    };

    return {
        restrict: 'A',
        scope: {
            resizeItem: '='
        },
        link: link
    };
});